export default __webpack_public_path__ + "static/media/gbmacc-platform-black.9fd12b8b.png";